import React, { type FC, memo, useCallback, useState } from "react";
import { Label, Radio, RadioGroup } from "@heroui/react";
import { type TUploadFile } from "@dms/types";

interface IProps {
    hash: string;
    files: TUploadFile[];
    handleSelectNotUniqFiles: (key: string, idx: number) => void;
}

const outerStyle: React.CSSProperties = {
    position: "relative",
    marginTop: "5px",
    padding: "8px",
    border: "1px solid #1677ff",
    borderRadius: "5px",
};
const innerStyle: React.CSSProperties = { padding: "5px 8px 0" };
const nameStyle: React.CSSProperties = { marginLeft: 5 };

const FilesSameHashItemImpl: FC<IProps> = ({ hash, files, handleSelectNotUniqFiles }) => {
    const [value, setValue] = useState<number>(0);

    const handleChange = useCallback(
        (nextValue: string) => {
            const index = Number(nextValue);
            setValue(index);
            handleSelectNotUniqFiles(hash, index);
        },
        [handleSelectNotUniqFiles, hash],
    );

    return (
        <div style={outerStyle}>
            <div style={innerStyle}>
                <RadioGroup onChange={handleChange} value={String(value)}>
                    {files.map((el, i) => {
                        const { file } = el;
                        return (
                            <Radio value={String(i)} key={el.hash + i}>
                                <Radio.Content>
                                    <Radio.Control className="border">
                                        <Radio.Indicator />
                                    </Radio.Control>
                                    <Label>
                                        <div style={nameStyle}>{file.name}</div>
                                    </Label>
                                </Radio.Content>
                            </Radio>
                        );
                    })}
                </RadioGroup>
            </div>
        </div>
    );
};

export const FilesSameHashItem = memo(FilesSameHashItemImpl);
